import { NgModule } from '@angular/core';

import { AvModalComponent } from './modal';
import { CommonModule } from '@angular/common';

@NgModule({
  imports: [ CommonModule ],
  exports: [ AvModalComponent ],
  declarations: [ AvModalComponent ],
  providers: [],
})
export class AvModalModule { }
